import { useInterfaceLanguage } from '@/shared/i18n';
import { PaymentInterval } from '@/shared/types/Billing';

import { SToggle, SToggleTab } from '../styled';

type PaywallBillingToggleProps = {
  isCompact: boolean;
  period: PaymentInterval;
  onChange: (period: PaymentInterval) => void;
};

export const PaywallBillingToggle = ({ isCompact, period, onChange }: PaywallBillingToggleProps) => {
  const { t } = useInterfaceLanguage();

  const tabs = [
    { label: t('pricing.billing.monthly'), value: PaymentInterval.Month },
    { label: t('pricing.billing.annual'), value: PaymentInterval.Year },
  ];

  return (
    <SToggle $isCompact={isCompact} aria-label={t('pricing.billing.aria')} role="tablist">
      {tabs.map((tab) => (
        <SToggleTab
          key={tab.value}
          $isCompact={isCompact}
          $isSelected={period === tab.value}
          aria-selected={period === tab.value}
          data-testid={`trial-paywall-experiment-billing-${tab.value}`}
          role="tab"
          tabIndex={0}
          onClick={() => period !== tab.value && onChange(tab.value)}
        >
          {tab.label}
        </SToggleTab>
      ))}
    </SToggle>
  );
};
